import { StringSimilarity } from "./StringSimilarity/StringSimilarity";

export function BringSearhQueryToTop(
  collectedItems,
  listArray,
  searchQuery,
  targetQuery,
  targetProp
) {
  const matchingIds = [];

  // Find matching objects based on searchQuery and targetQuery
  const matchingObjects = listArray.filter((obj) => {
    const similarity = StringSimilarity(searchQuery, obj[targetQuery]);
    return similarity > 0.6;
  });

  // Sort the matching objects by similarity in descending order
  matchingObjects.sort((a, b) => {
    const similarityA = StringSimilarity(searchQuery, a[targetQuery]);
    const similarityB = StringSimilarity(searchQuery, b[targetQuery]);
    return similarityB - similarityA;
  });

  // Get the top 10 matching Ids
  const topMatchingIds = matchingObjects
    .slice(0, 10)
    .map((obj) => obj[targetProp]);

  // Remove previously added matching items
  const previousMatchingIds = collectedItems.filter(
    (id) => !matchingIds.includes(id)
  );

  // Remove the previously added matching items from collectedItems
  collectedItems = collectedItems.filter(
    (id) => !previousMatchingIds.includes(id)
  );

  // Add new matching Ids after the already existing items in collectedItems
  for (const id of topMatchingIds) {
    if (!collectedItems.includes(id) && !matchingIds.includes(id)) {
      matchingIds.push(id);
    }
  }

  // Concatenate the previousMatchingIds, collectedItems, and matchingIds arrays
  const result = previousMatchingIds.concat(collectedItems, matchingIds);

  return result;
}
